/**
 * @file Service
 * @author fuqiang15
 */

import {includes} from 'lodash';
import uri from '@baidu/ve-ria/utils/uri';

const gen = operation => {
    let {event, disabled, url} = operation;
    if (!event && url) {
        operation.event = 'redirect';
    }
    operation.disabled = disabled;
    return operation;
};

export default class Service {
    id = null;
    raw = null;

    constructor(raw) {
        this.raw = raw;
        this.id = raw.id;
    }

    getGeneralOperations(auth, admin) {
        let operations = [];
        let {status, type, data} = this.raw;
        type = type.toLowerCase();
        let editAuth = type === 'custom' ? auth.custom : auth.service;
        let prefix = admin ? '' : '/app';

        const editOperation = gen({
            label: '编辑',
            url: uri.withQuery(`${prefix}/service/${this.id}/${type.toLowerCase()}/edit`),
            disabled: !editAuth
        });
        const deleteOperation = gen({
            label: '删除',
            args: this.id,
            event: 'delete',
            disabled: !editAuth
        });
        const detailOperation = gen({
            label: '查看',
            url: uri.withQuery(`${prefix}/service/${this.id}/${type.toLowerCase()}/detail`)
        });

        let arTemplateType = data ? JSON.parse(data).arTemplateType : null;
        switch (status) {
            case 'DRAFT':
                operations.push(editOperation, deleteOperation, detailOperation);
                break;
            case 'OFFLINE':
                operations.push(editOperation, detailOperation);
                break;
            case 'PUBLISHED':
            case 'ONLINE':
                if (includes(['lottery', 'schema'], type)) {
                    operations.push(editOperation, detailOperation);
                }
                else {
                    operations.push(detailOperation);
                }
                break;
            case 'REVIEWING':
                operations.push(detailOperation);
                break;
            case 'REJECT':
                operations.push(deleteOperation, detailOperation);
                if (type === 'ar' && arTemplateType === 'AR_TEMPLATE_EDITOR') {
                    operations.push(editOperation);
                }
                break;
        }
        return operations;
    }

    getSpecialOperations(auth, admin) {
        let operations = [];
        let {status, type, data} = this.raw;
        type = type.toLowerCase();
        let arTemplateType = data ? JSON.parse(data).arTemplateType : null;
        let prefix = admin ? '' : '/app';
        let editAuth = type === 'custom' ? auth.custom : auth.service;

        switch (type) {
            case 'ar':
                if (arTemplateType === 'AR_TEMPLATE_EDITOR') {
                    const copyOperation = gen({
                        label: '复制',
                        args: this.id,
                        event: 'copy',
                        disabled: !auth.service
                    });
                    operations.push(copyOperation);
                }
                break;
            case 'lottery': {
                const addLotteryOperation = gen({
                    label: '追加上传奖券',
                    url: uri.withQuery(`${prefix}/service/${this.id}/${type}/award/list`),
                    disabled: !auth.service
                });
                operations.push(addLotteryOperation);
                break;
            }
            case 'map':
            case 'map2':
                if (status !== 'DRAFT') {
                    const checkStoreListOperation = gen({
                        label: '查看门店列表',
                        url: uri.withQuery(`${prefix}/service/${this.id}/${type}/store/list`)
                    });
                    const editStoreOperation = gen({
                        label: '修改门店信息',
                        url: uri.withQuery(`${prefix}/service/${this.id}/${type}/store/edit`),
                        disabled: !auth.service
                    });
                    operations.push(checkStoreListOperation, editStoreOperation);
                }
                break;
            case 'custom': {
                const apiManageOperation = gen({
                    label: 'API管理',
                    url: uri.withQuery(`${prefix}/service/${this.id}/custom/api/list`)
                });
                // 只有处于上线状态得到自定义服务才具备下线功能
                if (status === 'PUBLISHED') {
                    operations.push(gen({
                        label: '下线',
                        args: this.id,
                        event: 'offline',
                        disabled: !editAuth
                    }));
                }
                operations.push(apiManageOperation);
                break;
            }
            case 'schema':
                if (includes(['ONLINE', 'PUBLISHED'], status)) {
                    const formDataOperation = gen({
                        label: '表单数据',
                        url: uri.withQuery(`${prefix}/service/${this.id}/${type}/data/list`),
                        disabled: !auth.service
                    });
                    operations.push(formDataOperation);
                }
                break;
        }
        return operations;
    }

    getOperations(auth, admin) {
        return [
            ...this.getGeneralOperations(auth, admin),
            ...this.getSpecialOperations(auth, admin)
        ];
    }
}
